// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { initializeApp } from "firebase/app";

export const environment = {
  production: false,
  firebaseConfig:{
    apiKey: "AIzaSyCZx5bW_PhpJvilImqpT5ZTnlNIf4nwBbg",
    authDomain: "amsystem-comercialo.firebaseapp.com",
    projectId: "amsystem-comercialo",
    storageBucket: "amsystem-comercialo.appspot.com",
    messagingSenderId: "822359052850",
    appId: "1:822359052850:web:1363fc142f31e81e8ba22b",
    measurementId: "G-MYSQYSV658"
  }
};
const app = initializeApp(environment.firebaseConfig);

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
//import 'zone.js/dist/zone-error';  // Included with Angular CLI.
